import React from 'react';
import { Badge } from '../ui/badge';

interface SubjectSelectorProps {
  subjects: any[];
  selectedSubject: any;
  onSubjectClick: (subject: any) => void;
}

export const SubjectSelector: React.FC<SubjectSelectorProps> = ({
  subjects,
  selectedSubject,
  onSubjectClick
}) => {
  if (!subjects || subjects.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-3">Subjects</h3>
      <div className="flex flex-wrap gap-2">
        {subjects.map(subject => (
          <Badge 
            key={subject.id}
            variant={selectedSubject?.subjectId === subject.subjectId ? "default" : "outline"}
            className={`cursor-pointer bg-gray-200 px-4 py-2 rounded-md ${
              selectedSubject?.subjectId === subject.subjectId 
                ? 'bg-primary hover:bg-primary/90' 
                : 'hover:bg-gray-300'
            }`}
            onClick={() => onSubjectClick(subject)}
          >
            {subject?.title || subject?.subjectName}
          </Badge>
        ))}
      </div>
    </div>
  );
};
